import { COLORS } from '../lib';

export const ArrowDownIcon = ({
  className,
  isActive,
  color,
}: {
  className?: string;
  isActive: boolean;
  color?: string;
}) => {
  const fillColor = color ?? COLORS['icon-base-300'];
  return (
    <svg
      className={className}
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      style={{
        transform: isActive ? 'rotate(-180deg)' : 'rotate(0deg)',
        transition: 'transform .3s ease-in-out',
      }}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.77095 7.5312C5.02153 7.27085 5.42781 7.27085 5.6784 7.5312L10.9997 13.0598L16.3209 7.5312C16.5715 7.27085 16.9778 7.27085 17.2284 7.5312C17.479 7.79155 17.479 8.21366 17.2284 8.47401L11.4534 14.474C11.2028 14.7344 10.7965 14.7344 10.5459 14.474L4.77095 8.47401C4.52036 8.21366 4.52036 7.79155 4.77095 7.5312Z"
        fill={fillColor}
      />
    </svg>
  );
};
